<template>
  <div class="ExclusiveDetalis">
    <navigator title="园区配套" :routePath='"/parkCompleteSet/exclusiveActivities"'></navigator>
    <div class="bigBox">
      <div class="header">
        <img :src="welfareinfo.banner" alt="" class="img_b">
        <div class="welfareinfo">
          <p class="title">{{welfareinfo.title }}</p>
          <p class="price">{{welfareinfo.discountLimit}}</p>
          <p class="welfare">数量: <span>{{welfareinfo.showNum}} </span>份 <span class="from">福利来自{{welfareinfo.providerName}}</span> </p>
        </div>
      </div>
      <div class="limTime">
        有效限期：{{welfareinfo.beginTime | DateFilter('yyyy-MM-dd hh:mm')}} 至 {{welfareinfo.endTime | DateFilter('yyyy-MM-dd hh:mm')}}
      </div>
      <div class="content">
        <div class="jieshao">
          产品介绍
        </div>
        <div class="text" v-html="welfareinfo.content"  ref="text"></div>
      </div>
    </div>

    <div v-if="welfareinfo.serviceQrcodeList">
      <QrcodeQuickEntry :serviceQrcodeList="welfareinfo.serviceQrcodeList"></QrcodeQuickEntry>
    </div>

    <div class="footer-fixed">
      <mt-button type="danger" class="footer-btn" @click="submit(welfareinfo.welfareId)">领 取</mt-button>
    </div>
  </div>
</template>
<script type="text/javascript" src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js" ></script>
<script>
import Navigator from '@/components/Navigator';
import { mapGetters, mapMutations } from 'vuex';
import { MessageBox, Toast } from 'mint-ui';
import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';
import $ from 'jquery';

export default {
  data() {
    return{
      welfareinfo: {},
      scanConfig: {   // 扫码配置参数
        appId: '',
        timestamp: '',
        nonceStr: '',
        signature: '',
      },
    }
  },
  methods: {
    submit(welfareId) {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else if (this.welfareinfo.linkUrl) {
        window.location.href = this.welfareinfo.linkUrl;
      } else {
        this.$http.post(`${this.URL_PREFIX}/app/added/welfare/order`,{
          welfareId: welfareId,
          parkId: Number(this.currentParkId),
          qrId: this.$route.query.bindQr==1 ? (this.qrcodeServiceInfo.qrId || undefined) : undefined,
        },{
          headers: { token: this.token },
        }).then((respon) =>{
          const res = respon.data;
          if (res.resCode === '10000') {
              MessageBox('提示', '领取成功');
          } else if (res.resCode === '12806') {
            MessageBox('提示', '该功能仅限已入驻园区的企业用户使用，请联系您的企业管理员。未入住园区的企业，请使用PC端在线提交入驻申请。');
          } else {
            Toast(res.resDesc);
          }
        });
      }
    },
    getinfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/welfare/info/detail`,{
        welfareId: this.$route.params.exclusiveDetalisId,
        parkId: Number(this.currentParkId),
        qrId: this.$route.query.qrId || '',
      }).then((res) =>{
        if(res.data.resCode === '10000') {
          this.welfareinfo = res.data.resData;
        }
      });
    },
    shere() {
      var imgUrl = 'http://wechat.tianan.net/img/det1.jpg'; 
      var lineLink = location.href.split('#')[0]; 
      var descContent = '主办单位：福田区妇女联合会、泰然天安科技园联合党委';
      var shareTitle = '三八节”关爱抗疫医护巾帼公益活动！';
      var appid = '';
      this.$http.post(`${this.URL_PREFIX}/app/get/wx/jssdk/config/info`, {
          url: location.href.split('#')[0]
        }, {
          headers: { token: this.token }
        }).then((response) => {
          const res = response.data;
          if (res.resCode === '10000') {
            this.scanConfig.appId = res.resData.appId;
            this.scanConfig.timestamp = res.resData.timestamp;
            this.scanConfig.nonceStr = res.resData.nonceStr;
            this.scanConfig.signature = res.resData.signature;
            wx.config({
                debug: false,
                appId: this.scanConfig.appId,
                timestamp: this.scanConfig.timestamp,
                nonceStr: this.scanConfig.nonceStr,
                signature: this.scanConfig.signature,
                jsApiList: [
                    'checkJsApi',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage'
                ]
            });
            wx.ready(function() {
                          
                          wx.onMenuShareTimeline({
                              title: shareTitle, // 分享标题
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                          wx.onMenuShareAppMessage({
                              title: shareTitle, // 分享标题
                              desc: descContent, // 分享描述
                              link: lineLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                              imgUrl: imgUrl, // 分享图标
                              type: '', // 分享类型,music、video或link，不填默认为link
                              dataUrl:'' , // 如果type是music或video，则要提供数据链接，默认为空
                              success: function () {
                                  // 用户确认分享后执行的回调函数
                                  
                              },
                              cancel: function () {
                                  // 用户取消分享后执行的回调函数
                              }
                          });
                  });
          } else {
            Toast.fail({ duration: 1500, message: res.resDesc });
          }
      });
    },
  },
  mounted() {
    this.getinfo();
    this.shere();
  },
  components: {
    Navigator,
  },
  computed: {
    ...mapGetters(['currentParkId','token','qrcodeServiceInfo']),
  },
  updated() {
    const imgs = this.$refs.text.querySelectorAll('img');
    imgs.forEach((val) => {
      val.style.maxWidth = '100%';
    });
  },
}
</script>
<style lang="scss" scoped>
@import '~@scss';

.header{
  color: rgb(51, 51, 51);
  background-color: #fff;
  .img_b{
    display: inline-block;
    height: 7.506667rem;
    width: 100%;
  }
  .welfareinfo{
    padding: .266667rem .32rem;
    box-sizing: border-box;
    .title{
      font-size: .453333rem;
      font-weight: bold;
    }
    .price{
      color: rgb(217, 38, 44);
      font-size: .4rem;
      margin-top: .266667rem;
    }
    .welfare{
      display: inline-block;
      font-size: .32rem;
      margin-top: .266667rem;
      .from{
        margin-left: .133333rem;
      }
    }
  }
}
.limTime{
  margin-top: .133333rem;
  background-color: #fff;
  height: 1.333333rem;
  line-height: 1.333333rem;
  padding: 0 .32rem;
  font-size: .4rem;
}
.content{
  background-color: #fff;
  padding-bottom: 1.66rem;
  .jieshao{
    padding: .36rem .32rem;
    box-sizing: border-box;
    font-size: .453333rem;
    font-weight: bold;
  }
  .text{
    padding: .293333rem .32rem;
  }
}
.footer-fixed{
  padding: px2rem(16) px2rem(24);
  background-color: #f5f5f5;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  bottom: 0;
  .footer-btn{
    width: 100%;
    background: $color-main;
    color: #fff;
    font-size: .4rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/parkCompleteSet/components/detalis/ExclusiveDetalis.vue